export const FETCH_USER = "FETCH_USER";
export const START_FETCHING_USER = "START_FETCHING_USER";
export const END_FETCHING_USER = "END_FETCHING_USER";
export const GET_COLLECTIONID = "GET_USERNAME";
